"use strict";
const core_1 = require("@angular/core");
exports.IMENUPROVIDERSERVICE_TOKEN = new core_1.OpaqueToken('IMenuProviderService');
